import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Lightbulb05 = function Lightbulb05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2v1m-9 9H2m3.5-6.5-.6001-.6001M18.5 5.5l.6002-.6001M22 12h-1m-11 1.5h4m-2 0v5m3.5-1.626C17.0141 15.7848 18 14.0075 18 12c0-3.3137-2.6863-6-6-6s-6 2.6863-6 6c0 2.0075.986 3.7848 2.5 4.874V18.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218h.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108z"
    })
  }));
};
export default Lightbulb05;